import React from 'react';

function LayersIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFF" fillRule="nonzero" transform="translate(-170 -1743)">
          <g transform="translate(136 1575)">
            <g transform="translate(34 168)">
              <path d="M22 7.333L11 0 0 7.333l11 7.334 11-7.334zM11 18.606L3.056 13.2 0 14.96 11 22l11-7.04-2.933-1.634L11 18.606z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default LayersIcon;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/Layers.js